module.exports = __webpack_public_path__ + "img/bha-map.0c93a5bc.svg";